import React, { useEffect, useState } from 'react'
import ContainerButton from '../../../components/button/ContainerButton'
import { routeName } from '../../../routes/routeName'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom'
import { useNavigate } from 'react-router-dom'
import HtmlRenderer from '../../../components/render-html/RenderHtml'
import { ContentPDPAApi } from '../../../api/content-pdpa/content-pdpa.api'

export default function CheckPDPA() {
    const { t } = useTranslation();
    const navigate = useNavigate()

    const [check, setCheck] = useState<boolean>(false)
    const [form, setForm] = useState<any>()

    const getDetail = async () => {
        await ContentPDPAApi.findOne()
            .then((res) => {
                if (res.status < 300) {
                    setForm(res.data.data)
                }
            })
            .catch((err) => {
                console.log(err);
                // alertError("เพิ่มข้อสอบ", "เพิ่มข้อสอบ ไม่สำเร็จ");
            })
            .finally(() => {
                // dispatch(unsetLoading());
            });
    }

    useEffect(() => {
        getDetail()
    }, [])
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("Terms and Conditions for the Collection, Use, and Disclosure of Personal Data")}
                hidden_sub_title

                content={
                    <div className='w-full'>
                        <Box>
                            {form?.content_pdpa ? <HtmlRenderer html={form?.content_pdpa} />: <></>}
                        </Box>
                        <CheckBoxCustom checked={check} setChecked={setCheck} label='I hereby accept the terms and conditions for the collection, use, and disclosure of personal data in accordance with the Personal Data Protection Act (PDPA).' />
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { },
                                    },
                                    key: "CANCEL",
                                    label: "Cancel",
                                    type: "CANCEL"
                                },

                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => { navigate(routeName.admission.AdmissionForm) },
                                        disabled: !check
                                    },
                                    key: "NONE",
                                    label: "Confirm",
                                    type: "NONE"
                                },
                            ]}
                        />
                    </div>
                }
            />

        </div>
    )
}
